import React, { Component } from 'react';
import './CustomReportsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Divider from '../../components/divider/Divider';
import history from '../../history';
import models from '../../model/models';
import UpdateTitle from '../../components/updateTitle/UpdateTitle';

let Row = (props) => {
	return (
		<div className="row">
			<Label gray-dark>{props.name}</Label>
			<Label gray-dark>{props.createdOn}</Label>
			<Label blue>View</Label>
		</div>
	);
};
let Report = (props) => {
	return (
		<Card
			tabIndex="0"
			className="report"
			onClick={() => {
				history.navigate(props.url);
			}}
		>
			<Label blue large>
				{props.title}
			</Label>
			<Label medium-small black>
				{props.description}
			</Label>
			<Label gray-medium medium-small />
		</Card>
	);
};
export default class CustomReportsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount = () => {
		this.subscribeId = models.report.onChange(this._getData);
	};

	componentWillUnmount = () => {
		models.report.unsubscribe(this.subscribeId);
	};

	_getData = () => {
		let reports = models.report.objs();
		this.setState({ reports });
	};

	_renderReports = () => {
		let displayReports = [];
		for (let i in this.state.reports) {
			let report = this.state.reports[i];
			displayReports.push(
				<Report key={i} title={report.name} description={report.description} url={'/reports/custom/' + report.id} />
			);
		}
		return displayReports;
	};

	render() {
		return (
			<Page className="g-custom-reports-page">
				<UpdateTitle newTitle="Reports" originalTitle="LogRx" />
				<Card className="main">
					<div className="top-row">
						<Label isHeader="true" larger black>
							Reports
						</Label>
					</div>
					<div className="options-row">
						<Label
							tabIndex="0"
							gray-medium
							onClick={() => {
								history.navigate('/reports/recommended');
							}}
						>
							Recommended
						</Label>
						<Label black bold>
							Saved Reports
						</Label>
					</div>
					<Divider />
					<div className="reports">{this._renderReports()}</div>
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/customReportsPage/CustomReportsPage.jsx